import { render } from "./OneProductBox.vue?vue&type=template&id=b8f72c4e&scoped=true"
import script from "./OneProductBox.vue?vue&type=script&lang=js"
export * from "./OneProductBox.vue?vue&type=script&lang=js"

import "./OneProductBox.vue?vue&type=style&index=0&id=b8f72c4e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8f72c4e"]])

export default __exports__